export class RecipeQuantity {
    ingredient: string;
    is_main: boolean;
    quantity: string;
    extra: string | null;
    unit: {
      english: 'kg' | 'g' | 'mg' | 'ml' | 'l' | 'pcs' | 'u' | 'tsp' | 'tbsp' | 'cup' | 'oz' | null,
      spanish: 'kg' | 'g' | 'mg' | 'ml' | 'l' | 'pzs' | 'u' | 'cucharadita' | 'cucharada' | 'taza' | 'oz' | null
    } = {
        english: 'u',
        spanish: 'u'
    };
  
    constructor(
      ingredient: string = '',
      is_main: boolean = false,
      quantity: string = '',
      extra: string | null = null,
      unit: {
        english: 'kg' | 'g' | 'mg' | 'ml' | 'l' | 'pcs' | 'u' | 'tsp' | 'tbsp' | 'cup' | 'oz' | null,
        spanish: 'kg' | 'g' | 'mg' | 'ml' | 'l' | 'pzs' | 'u' | 'cucharadita' | 'cucharada' | 'taza' | 'oz' | null
      } = {
          english: 'u',
          spanish: 'u'
      }
    ) {
      this.ingredient = ingredient;
      this.is_main = is_main;
      this.quantity = quantity;
      this.extra = extra;
      this.unit = unit;
    }
  }

  export const units = [
    { english: 'kg', spanish: 'kg' },
    { english: 'g', spanish: 'g' },
    { english: 'mg', spanish: 'mg' },
    { english: 'ml', spanish: 'ml' },
    { english: 'l', spanish: 'l' },
    { english: 'pcs', spanish: 'pzs' },
    { english: 'u', spanish: 'u' },
    { english: 'tsp', spanish: 'cucharadita' },
    { english: 'tbsp', spanish: 'cucharada' },
    { english: 'cup', spanish: 'taza' },
    { english: 'oz', spanish: 'oz' },
];